import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'

import { AppWrap, MotionWrap } from '../../wrapper';
import './About.scss'; 
import { urlFor, client } from '../../client'; 
// import { images } from '../../constants'

// -- Static Data -- 
// const abouts = [
//   { title: 'Web Development', description: 'I am a good web developer.', imgUrl: images.about01},
//   { title: 'Frontend Development', description: 'I am a good Front End Engineer.', imgUrl: images.about02},
//   { title: 'Backend Development', description: 'I am a good Back End Engineer.', imgUrl: images.about03},
//   { title: 'MERN Stack', description: 'I am a good web animator.', imgUrl: images.about04},
// ];

const About = () => {
  
  // -- Dynamic Data -- 
  // Allows us to fetch real Dynamic data from a CMS 
  const [abouts, setAbouts] = useState([]); 
  // We only want to run our useEffect() at the start once our component loads 
  useEffect(() => {
    // Query for fetching our about section 
    const query = '*[_type == "abouts"]'

    client.fetch(query)
      .then((data) => setAbouts(data))
  }, []);

  return (
    <>

      <h2 className='head-text'> I know that <span>Good Development</span> <br /> means <span>Good Business</span></h2>

      <div className='app__profiles'>
        {abouts.map((about, index) => (
          <motion.div
          // Animation Properties
          whileInView={{ opacity: 1}}
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.5, type: 'tween' }}
          className='app__profile-item'
          key={about.title + index}
          >
            {/*  Note : We have to use Sanity provided function urlFor() */}
            <img src={urlFor(about.imgUrl)} alt={about.title} /> 
            <h2 className='bold-text' style={{ marginTop: 20 }}>{about.title}</h2>
            <p className='p-text' style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>

    </>
  )
}

// Double Wrapping About Component 
export default AppWrap(
  // Wrapping the About component in MotionWrap and giving it an extra class name of app__about
  MotionWrap(About, 'app__about'),
  // Giving the section an id of 'about'
  'about',
  // Giving the secion a white background (alternate background colors)
  "app__whitebg"
);